import React, { Component } from 'react'
import Mines from './components/Mines'

class App extends Component {
  render() {
    return <Mines />
  }
}

export default App
